import { useState, useEffect } from 'react';

export enum ImageOrientation {
  vertical = 'vertical',
  horizontal = 'horizontal',
  square = 'square',
}

type UseGetImageOrientationUtil = {
  imageOrientation: ImageOrientation;
};

export const useGetImageOrientation = (image: string | undefined): UseGetImageOrientationUtil => {
  const [orientation, setOrientation] = useState(ImageOrientation.vertical);

  useEffect(() => {
    if (typeof window !== 'undefined' && image) {
      const newImg = new Image();

      newImg.onload = () => {
        const { height } = newImg;
        const { width } = newImg;

        if (height > width) {
          setOrientation(ImageOrientation.horizontal);
        } else if (height === width) {
          setOrientation(ImageOrientation.square);
        } else {
          setOrientation(ImageOrientation.vertical);
        }
      };
      newImg.src = image;
    }
  }, [image]);

  return {
    imageOrientation: orientation,
  };
};
